module.exports = __webpack_public_path__ + "media/images/pushup2-3ef2835e784fb3e5890925a41619ce8f.png";